export const REGIONS = {
  US: 'us',
  EU: 'eu',
} as const;
